import { jsx as _jsx } from "react/jsx-runtime";
import { PendingButton } from "@ploy-ui/core";
import { useFormikContext } from "formik";
import Typography from "@material-ui/core/Typography";
export const SubmitButton = (props) => {
    const { children, ...rest } = props;
    const formik = useFormikContext();
    return (_jsx(PendingButton, { type: "submit", pending: formik.isSubmitting, disabled: !formik.isValid, ...rest, children: children }));
};
export const SubmitStatusMessage = () => {
    const formik = useFormikContext();
    const { status: { submit } = {} } = formik;
    return submit ? (_jsx(Typography, { color: submit.status || "info", children: submit.message })) : null;
};
//# sourceMappingURL=SubmitButton.js.map